import { createContext } from 'react';

export type ElevateContextType = {
  zIndex: number;
};

export const ElevateContext = createContext<ElevateContextType | null>(null);
